const USERS = 'USERS';
const USER_SETTINGS = 'USER_SETTINGS';
const FACTORY_ADD = 'FACTORY_ADD';
const BRAND_ADD = 'BRAND_ADD';
const MODEL_ADD = 'MODEL_ADD';
const DEVICE_ADD = 'DEVICE_ADD';
const PROTOCOL_ADD = 'PROTOCOL_ADD';
const CHANNEL_ADD = 'CHANNEL_ADD';
const ITEM_ADD = 'ITEM_ADD';
const ALERT_SETTING_ADD = 'ALERT_SETTING_ADD';
const ADD_DEVICE_TO_DIAGRAM = 'ADD_DEVICE_TO_DIAGRAM';
const ADD_COMPONENT_TO_DASHBOARD = 'ADD_COMPONENT_TO_DASHBOARD';
const DEVICE_DIAGRAM_DETAIL = 'DEVICE_DIAGRAM_DETAIL';

export default {
  USERS,
  USER_SETTINGS,
  FACTORY_ADD,
  BRAND_ADD,
  MODEL_ADD,
  DEVICE_ADD,
  PROTOCOL_ADD,
  CHANNEL_ADD,
  ITEM_ADD,
  ADD_DEVICE_TO_DIAGRAM,
  ALERT_SETTING_ADD,
  ADD_COMPONENT_TO_DASHBOARD,
  DEVICE_DIAGRAM_DETAIL,
};
